import { cloudChiprApi } from "../../../services/cloudchipr.api";

export const smartTagSettingSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentSettingsByKey.select({
    key: "smart_tag_ttl",
  });
